<template>
    <span 
        class="cursor-pointer text-theme" 
        :class="className"
        @click="getNextDate"
    >
        <SquareArrowRight
            :size="size"
            :stroke-width="strokeWidth"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :data-bs-title="title"
        />
    </span>
</template>

<script>
import {appMixin} from '../../mixin/appMixin';
import {
    SquareArrowRight
} from 'lucide-vue-next';

export default {
    name: 'NextDateIcon',
    mixins: [appMixin],
    components: {
        SquareArrowRight
    },
    props: {
        modelValue: {
            default: new Date(),
        },
        className: {
            type: String,
            default: ''
        },
        increment: {
            type: String,
            default: 'day' // day, month, or year
        },
        size: {
            type: Number,
            default: 24
        },
        strokeWidth: {
            type: Number,
            default: 2
        },
        title: {
            type: String,
            default: 'Next Date'
        }
    },
    methods: {
        getNextDate() {
            let nextDate = this.momentObj(this.modelValue);
            // increment by type
            if(this.increment === 'day') {
                nextDate.add(1, 'day');
            } else if(this.increment === 'month') {
                nextDate.add(1, 'month');
            } else if(this.increment === 'year') {
                nextDate.add(1, 'year');
            }
            this.$emit('update:modelValue', nextDate);
        }
    }
}
</script>